export function isLoggedIn() {
  return !!localStorage.getItem('auth_details');
}

export function logoutUser() {
  localStorage.removeItem('auth_details');
}

